import { createFileRoute } from "@tanstack/react-router";
import { GroupEnrollmentTransfers } from "@/components/admin/therapies/GroupEnrollmentTransfers";

export const Route = createFileRoute("/dashboard/admin/group-enrollments")({
  component: GroupEnrollmentTransfers,
});
